import { render, staticRenderFns } from "./teaching-resource-collections.vue?vue&type=template&id=3e916934"
import script from "./teaching-resource-collections.vue?vue&type=script&lang=js"
export * from "./teaching-resource-collections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports